import React, { PureComponent } from 'react'
import { Grid, Tabs, Tab, Paper, ListItem, FormLabel } from '@material-ui/core'
import QuickBookList from './QuickBookList'
import { getQuickBookOperations } from '../../actions/thirdParty'
import ContainerWithTitleWrapper from '../../containers/HOC/ContainerWithTitle'
import connect from 'react-redux/es/connect/connect'

class QuickBookConfig extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'Vendor',
      quickbookOpt: {},
    }
    this.handleTabChange = this.handleTabChange.bind(this)
  }
  componentDidMount() {
    this.getQuickBookOperations()
  }

  getQuickBookOperations = () => {
    this.props.dispatch(getQuickBookOperations()).then((res) => {
      const qbDesktopOperations = res.qbDesktopOperations
      const quickBookDesktopAccountsMap = res.quickBookDesktopAccountsMap
      this.setState({
        quickbookOpt: {
          qbDesktopOperations,
          quickBookDesktopAccountsMap,
        },
      })
    })
  }

  handleTabChange = (event, tab) => {
    this.setState({
      activeTab: tab,
    })
  }

  updateQuickBookOperations = () => {
    this.props.updateQuickBookOperations(this.state.quickbookOpt.qbDesktopOperations)
  }
  reSync = (data) => {
    this.props.reSync(data)
  }
  renderTab = (activeTab) => {
    return (
      <QuickBookList
        data={
          this.state &&
          this.state.quickbookOpt &&
          this.state.quickbookOpt.qbDesktopOperations &&
          this.state.quickbookOpt.qbDesktopOperations
            .filter((res) => res.operationType == activeTab)
            .map((res) => res)
        } // eslint-disable-line
        allSelectData={
          this.state && this.state.quickbookOpt && this.state.quickbookOpt.qbDesktopOperations
        }
        activeTab={activeTab}
        onSave={this.updateQuickBookOperations}
        onReSync={this.reSync}
      />
    )
  }
  render() {
    this.state.quickbookOpt &&
      this.state.quickbookOpt.qbDesktopOperations &&
      this.state.quickbookOpt.qbDesktopOperations.map((res) =>
        console.log('props config', res.operationType),
      )
    const { activeTab } = this.state
    return this.state &&
      this.state.quickbookOpt &&
      this.state.quickbookOpt.qbDesktopOperations &&
      this.state.quickbookOpt.qbDesktopOperations.length > 0 ? (
      <Grid>
        <Grid item lg={12}>
          <Paper className="margin-top-xs ">
            <Tabs
              //value={activeTab}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              centered={true}
            >
              {this.state &&
                this.state.quickbookOpt &&
                this.state.quickbookOpt.qbDesktopOperations &&
                this.state.quickbookOpt.qbDesktopOperations.length > 0 &&
                this.state.quickbookOpt.qbDesktopOperations
                  .filter((res) => res.enabled)
                  .map((res) => (
                    <Tab
                      className={res.syncPaused ? 'highlighter' : ''}
                      label={res.displayName}
                      value={res.operationType}
                    />
                  ))}
            </Tabs>
          </Paper>
          {this.renderTab(activeTab)}
        </Grid>
      </Grid>
    ) : (
      <Grid item lg={12}>
        <Paper className="margin-top-xs">
          {' '}
          <ListItem>
            <FormLabel component="legend">Configs are not available yet.</FormLabel>
          </ListItem>
        </Paper>
      </Grid>
    )
  }
}
const QuickBookConfigWithTitle = ContainerWithTitleWrapper(QuickBookConfig, 'QuickBookConfig')
export default connect((state) => {
  return {
    dispatch: state.dispatch,
    shopReducer: state.shopReducer,
  }
})(QuickBookConfigWithTitle)



// WEBPACK FOOTER //
// ./src/components/QuickBook/QuickBookConfig.js